import { productGroupConstants } from "../constants";

export const getProductGroups = (params) => {
    return {
        type: productGroupConstants.GET_PRODUCT_GROUPS,
        params
    }
}

export const createProductGroup = (formData) => {
    return {
        type: productGroupConstants.CREATE_PRODUCT_GROUP,
        formData
    }
}

export const updateProductGroup = (formData) => {
    return {
        type: productGroupConstants.UPDATE_PRODUCT_GROUP,
        formData
    }
}

export const changeProductGroupStatus = (formData) => {
    return {
        type: productGroupConstants.CHANGE_PRODUCT_GROUP_STATUS,
        formData
    }
}

export const deleteProductGroup = (id) => {
    return {
        type: productGroupConstants.DELETE_PRODUCT_GROUP,
        id
    }
}

export const assignProductsToSubGroup = ({ subGroupId, productIds }) => {
    return {
        type: productGroupConstants.ASSIGN_PRODUCTS_TO_SUBGROUP,
        subGroupId,
        productIds
    }
}

export const clearProductGroupMsg = () => {
    return {
        type: productGroupConstants.CLEAR_PRODUCT_GROUP_MSG
    }
}

export const getProductGroupDropdown = () => {
    return {
        type: productGroupConstants.GET_PRODUCT_GROUP_DROPDOWN
    }
}
